import { ThemeType } from "grommet";

const isNominet = window.location.hostname.endsWith(".nominet.uk") || window.location.pathname.startsWith('/nominet');

export const theme: ThemeType = {
	"anchor": {
		"color": "link",
	},
	"global": {
		"colors": {
			"link": "brand",
			"tableHeaderBackgroundColor": "brand-green",
			"brand": {
				"dark": "#0077bf",
				"light": "#00a966"
			},
			"brand-blue": "#0077bf",
			"brand-green": "#00a966",
			"background": {
				"dark": "#111111",
				"light": "#FFFFFF"
			},
			"background-back": {
				"dark": "#111111",
				"light": "#EEEEEE"
			},
			"background-front": {
				"dark": "#222222",
				"light": "#FFFFFF"
			},
			"background-contrast": {
				"dark": "#FFFFFF11",
				"light": "#11111111"
			},
			"text": {
				"dark": "#FFFFFF",
				"light": "#000000"
			},
			"text-strong": {
				"dark": "#FFFFFF",
				"light": "#000000"
			},
			"text-weak": {
				"dark": "#CCCCCC",
				"light": "#444444"
			},
			"text-xweak": {
				"dark": "#999999",
				"light": "#666666"
			},
			"border": {
				"dark": "#444444",
				"light": "#4E89BA"
			},
			"control": "brand",
			"active-background": "background-contrast",
			"active-text": "text-strong",
			"selected-background": "brand",
			"selected-text": "text-strong",
			"status-critical": "#F84A00",
			"status-warning": "#F89000",
			"status-ok": "#49C090",
			"status-unknown": "#CCCCCC",
			"status-disabled": "#CCCCCC",
			"graph-0": "brand",
			"graph-1": "status-warning",
			"focus": "#005088"
		},
		"font": {
			"family": isNominet ? "Metropolis" : "Inter",
			"size": "12px",
			"height": "16px",
			"maxWidth": "192px"
		},
		"active": {
			"background": "active-background",
			"color": "active-text"
		},
		"hover": {
			"background": "active-background",
			"color": "active-text"
		},
		"selected": {
			"background": "selected-background",
			"color": "selected-text"
		},
		"borderSize": {
			"xsmall": "1px",
			"small": "2px",
			"medium": "3px",
			"large": "8px",
			"xlarge": "16px"
		}
	},
	"button": {
		"border": {
			"width": "2px",
			"radius": "0px"
		},
		"padding": {
			"vertical": "2px",
			"horizontal": "14px"
		},
		"size": {
			"small": {
				"border": {
					"radius": "0px"
				}
			}
		}
	},
	"table": {
		"header": {
			"background": "tableHeaderBackgroundColor",
			"pad": {
				"horizontal": "small",
				"vertical": "small"
			}
		}
	},
	"text": {
		"xsmall": {
			"size": "10px",
			"height": "14px",
			"maxWidth": "149px"
		},
		"small": {
			"size": "12px",
			"height": "16px",
			"maxWidth": "171px"
		},
		"medium": {
			"size": "14px",
			"height": "18px",
			"maxWidth": "192px"
		},
		"large": {
			"size": "16px",
			"height": "20px",
			"maxWidth": "235px"
		},
		"xlarge": {
			"size": "18px",
			"height": "22px",
			"maxWidth": "277px"
		},
		"xxlarge": {
			"size": "24px",
			"height": "28px",
			"maxWidth": "363px"
		}
	}
};


// export const theme: ThemeType = {
// 	// "name": "CleanDNS",
// 	// "rounding": 2,
// 	// "spacing": 12,
// 	// "defaultMode": "light",
// 	"anchor": {
// 		"color": "link",
// 	},
// 	"global": {
// 		"colors": {
// 			"headerBackgroundColor": "white",
// 			"headerLinkColor": "brand",
// 			"brand": "#00a966",
// 			"link": "#0077bf",
// 			"tableHeaderBackgroundColor": "black",
// 			"tableHeaderTextColor": "white",
// 			"tableBorderColor": "brand",

// 			"background": "#FFFFFF",
// 			"background-flip": "#FFFFFF",
// 			"background-back": "#EEEEEE",
// 			"background-front": "#FFFFFF",
// 			"background-shade": "#DDDDDD",
// 			"background-contrast": "#11111111",
//       "text": {
//         "dark": "#FFFFFF",
//         "light": "#000000"
//       },
//       "text-strong": {
//         "dark": "#FFFFFF",
//         "light": "#000000"
//       },
//       "text-weak": {
//         "dark": "#CCCCCC",
//         "light": "#444444"
//       },
//       "text-xweak": {
//         "dark": "#999999",
//         "light": "#666666"
//       },
// 			"border": "#4E89BA",
// 			"control": "brand",
// 			"active-background": "background-contrast",
// 			"active-text": "text-strong",
// 			"selected-background": "brand",
// 			"selected-text": "text-strong",
// 			"status-critical": "#F84A00",
// 			"status-warning": "#F89000",
// 			"status-ok": "#49C090",
// 			"status-unknown": "#CCCCCC",
// 			"status-disabled": "#CCCCCC",
// 			"graph-0": "brand",
// 			"graph-1": "status-warning",
// 			"focus": "#005088"
// 		},
// 		"font": {
// 			"family": "Inter",
// 			"size": "12px",
// 			"height": "16px",
// 			"maxWidth": "192px"
// 		},
// 		"active": {
// 			"background": "active-background",
// 			"color": "active-text"
// 		},
// 		"hover": {
// 			"background": "active-background",
// 			"color": "active-text"
// 		},
// 		"selected": {
// 			"background": "selected-background",
// 			"color": "selected-text"
// 		},
// 		"control": {
// 			"border": {
// 				"radius": "4px"
// 			}
// 		},
// 		"drop": {
// 			"border": {
// 				"radius": "4px"
// 			}
// 		},
// 		"borderSize": {
// 			"xsmall": "1px",
// 			"small": "2px",
// 			"medium": "3px",
// 			"large": "8px",
// 			"xlarge": "16px"
// 		},
// 		"breakpoints": {
// 			"small": {
// 				"value": 512,
// 				"borderSize": {
// 					"xsmall": "1px",
// 					"small": "2px",
// 					"medium": "3px",
// 					"large": "4px",
// 					"xlarge": "8px"
// 				},
// 				"edgeSize": {
// 					"none": "0px",
// 					"hair": "1px",
// 					"xxsmall": "2px",
// 					"xsmall": "2px",
// 					"small": "4px",
// 					"medium": "8px",
// 					"large": "16px",
// 					"xlarge": "32px"
// 				},
// 				"size": {
// 					"xxsmall": "16px",
// 					"xsmall": "32px",
// 					"small": "64px",
// 					"medium": "128px",
// 					"large": "256px",
// 					"xlarge": "512px",
// 					"full": "100%"
// 				}
// 			},
// 			"medium": {
// 				"value": 1024
// 			},
// 			"large": {}
// 		},
// 		"edgeSize": {
// 			"none": "0px",
// 			"hair": "1px",
// 			"xxsmall": "2px",
// 			"xsmall": "4px",
// 			"small": "8px",
// 			"medium": "16px",
// 			"large": "32px",
// 			"xlarge": "64px",
// 			"responsiveBreakpoint": "small"
// 		},
// 		"input": {
// 			"padding": "8px",
// 			"weight": 600
// 		},
// 		"spacing": "16px",
// 		"size": {
// 			"xxsmall": "32px",
// 			"xsmall": "64px",
// 			"small": "128px",
// 			"medium": "256px",
// 			"large": "512px",
// 			"xlarge": "768px",
// 			"xxlarge": "1024px",
// 			"full": "100%"
// 		},
// 		"elevation": {
// 			"light": {
// 				"none": "none",
// 				"xsmall": "0px 1px 2px rgba(80, 80, 80, 0.85)",
// 				"small": "0px 2px 4px rgba(80, 80, 80, 0.85)",
// 				"medium": "0px 3px 8px rgba(80, 80, 80, 0.85)",
// 				"large": "0px 6px 12px rgba(80, 80, 80, 0.85)",
// 				"xlarge": "0px 8px 16px rgba(80, 80, 80, 0.85)"
// 			},
// 			"dark": {
// 				"none": "none",
// 				"xsmall": "0px 2px 2px rgba(80, 80, 80, 0.85)",
// 				"small": "0px 4px 4px rgba(80, 80, 80, 0.85)",
// 				"medium": "0px 6px 8px rgba(80, 80, 80, 0.85)",
// 				"large": "0px 8px 16px rgba(80, 80, 80, 0.85)",
// 				"xlarge": "0px 10px 24px rgba(80, 80, 80, 0.85)"
// 			}
// 		}
// 	},
// 	"chart": {},
// 	"diagram": {
// 		"line": {}
// 	},
// 	"meter": {},
// 	"tip": {
// 		"drop": {
// 			"background": { "color": "light-1" },
// 			"margin": { "vertical": "small" },
// 			"round": "xsmall",
// 			"elevation": "large"
// 		},
// 		"content": {
// 			"elevation": "none",
// 			"background": "none",
// 			"pad": "small"
// 		}
// 	},
// 	"layer": {
// 		"background": {
// 			"dark": "#111111",
// 			"light": "#FFFFFF"
// 		}
// 	},
// 	// "email": "chad.losschumacher@cleandns.email",
// 	// "date": "2023-02-25T03:04:41.364Z",
// 	"button": {
// 		"border": {
// 			"width": "2px",
// 			"radius": "0px"
// 		},
// 		"padding": {
// 			"vertical": "2px",
// 			"horizontal": "14px"
// 		}
// 	},
// 	"card": {
// 		"header": {
// 			"pad": { "horizontal": "medium", "top": "medium", "bottom": "small" }
// 		},
// 		"body": {
// 			"pad": { "horizontal": "medium", "top": "xsmall", "bottom": "medium" }
// 		},
// 		"container": {
// 			"elevation": "none",
// 			"round": "medium",
// 			"border": {
// 				"color": "brand"
// 			}
// 		},
// 		// "gap": "small" <-- does this belong within one of the above sections?
// 	},
// 	"checkBox": {
// 		"size": "16px",

// 		"check": {
// 			"radius": "4px",
// 		},
// 		"toggle": {
// 			"radius": "20px",
// 			"size": "32px"
// 		},
// 	},
// 	"radioButton": {
// 		"size": "16px"
// 	},
// 	"dataTable": {
// 		"header": {
// 			"font": { size: "medium" },
// 			"background": "tableHeaderBackgroundColor", // this is broken, it's always dark mode's brand
// 			"color": "tableHeaderTextColor",
// 		},
// 	},
//   "table": {
//     "header": {
// 			"background": "tableHeaderBackgroundColor", // this is broken, it's always dark mode's brand
//     }
//   },
// 	"formField": {
// 		"border": {
// 			"color": "border",
// 			"error": {
// 				"color": {
// 					"dark": "white",
// 					"light": "status-critical"
// 				}
// 			},
// 			"position": "outer",
// 			"side": "bottom",
// 			"size": "small"
// 		},
// 		"content": {
// 			"pad": "small"
// 		},
// 		"disabled": {
// 			"background": {
// 				"color": "status-disabled",
// 				"opacity": "medium"
// 			}
// 		},
// 		"error": {
// 			"color": "status-critical",
// 			"margin": {
// 				"vertical": "xsmall",
// 				"horizontal": "small"
// 			}
// 		},
// 		"help": {
// 			"color": "dark-3",
// 			"margin": {
// 				"start": "small"
// 			}
// 		},
// 		"info": {
// 			"color": "text-xweak",
// 			"margin": {
// 				"vertical": "xsmall",
// 				"horizontal": "small"
// 			}
// 		},
// 		"label": {
// 			"margin": {
// 				"vertical": "xsmall",
// 				"horizontal": "small"
// 			}
// 		},
// 		"margin": {
// 			"bottom": "small"
// 		},
// 		"round": "4px"
// 	},

// 	// "scale": 1,
// 	"calendar": {
// 		"small": {
// 			"fontSize": "9.333333333333334px",
// 			"lineHeight": 1.375,
// 			"daySize": "18.29px"
// 		},
// 		"medium": {
// 			"fontSize": "12px",
// 			"lineHeight": 1.45,
// 			"daySize": "36.57px"
// 		},
// 		"large": {
// 			"fontSize": "20px",
// 			"lineHeight": 1.11,
// 			"daySize": "73.14px"
// 		}
// 	},
// 	"clock": {
// 		"analog": {
// 			"hour": {
// 				"width": "5px",
// 				"size": "16px"
// 			},
// 			"minute": {
// 				"width": "3px",
// 				"size": "8px"
// 			},
// 			"second": {
// 				"width": "2px",
// 				"size": "6px"
// 			},
// 			"size": {
// 				"small": "48px",
// 				"medium": "64px",
// 				"large": "96px",
// 				"xlarge": "144px",
// 				"huge": "192px"
// 			}
// 		},
// 		"digital": {
// 			"text": {
// 				"xsmall": {
// 					"size": "6.666666666666667px",
// 					"height": 1.5
// 				},
// 				"small": {
// 					"size": "9.333333333333334px",
// 					"height": 1.43
// 				},
// 				"medium": {
// 					"size": "12px",
// 					"height": 1.375
// 				},
// 				"large": {
// 					"size": "14.666666666666666px",
// 					"height": 1.167
// 				},
// 				"xlarge": {
// 					"size": "17.333333333333332px",
// 					"height": 1.1875
// 				},
// 				"xxlarge": {
// 					"size": "22.666666666666664px",
// 					"height": 1.125
// 				}
// 			}
// 		}
// 	},
// 	// "heading": {
// 	// 	"level": {
// 	// 		"1": {
// 	// 			"small": {
// 	// 				"size": "23px",
// 	// 				"height": "27px",
// 	// 				"maxWidth": "363px"
// 	// 			},
// 	// 			"medium": {
// 	// 				"size": "33px",
// 	// 				"height": "37px",
// 	// 				"maxWidth": "533px"
// 	// 			},
// 	// 			"large": {
// 	// 				"size": "55px",
// 	// 				"height": "59px",
// 	// 				"maxWidth": "875px"
// 	// 			},
// 	// 			"xlarge": {
// 	// 				"size": "76px",
// 	// 				"height": "80px",
// 	// 				"maxWidth": "1216px"
// 	// 			}
// 	// 		},
// 	// 		"2": {
// 	// 			"small": {
// 	// 				"size": "20px",
// 	// 				"height": "24px",
// 	// 				"maxWidth": "320px"
// 	// 			},
// 	// 			"medium": {
// 	// 				"size": "28px",
// 	// 				"height": "32px",
// 	// 				"maxWidth": "448px"
// 	// 			},
// 	// 			"large": {
// 	// 				"size": "36px",
// 	// 				"height": "40px",
// 	// 				"maxWidth": "576px"
// 	// 			},
// 	// 			"xlarge": {
// 	// 				"size": "44px",
// 	// 				"height": "48px",
// 	// 				"maxWidth": "704px"
// 	// 			}
// 	// 		},
// 	// 		"3": {
// 	// 			"small": {
// 	// 				"size": "17px",
// 	// 				"height": "21px",
// 	// 				"maxWidth": "277px"
// 	// 			},
// 	// 			"medium": {
// 	// 				"size": "23px",
// 	// 				"height": "27px",
// 	// 				"maxWidth": "363px"
// 	// 			},
// 	// 			"large": {
// 	// 				"size": "28px",
// 	// 				"height": "32px",
// 	// 				"maxWidth": "448px"
// 	// 			},
// 	// 			"xlarge": {
// 	// 				"size": "33px",
// 	// 				"height": "37px",
// 	// 				"maxWidth": "533px"
// 	// 			}
// 	// 		},
// 	// 		"4": {
// 	// 			"small": {
// 	// 				"size": "15px",
// 	// 				"height": "19px",
// 	// 				"maxWidth": "235px"
// 	// 			},
// 	// 			"medium": {
// 	// 				"size": "17px",
// 	// 				"height": "21px",
// 	// 				"maxWidth": "277px"
// 	// 			},
// 	// 			"large": {
// 	// 				"size": "20px",
// 	// 				"height": "24px",
// 	// 				"maxWidth": "320px"
// 	// 			},
// 	// 			"xlarge": {
// 	// 				"size": "23px",
// 	// 				"height": "27px",
// 	// 				"maxWidth": "363px"
// 	// 			}
// 	// 		},
// 	// 		"5": {
// 	// 			"small": {
// 	// 				"size": "11px",
// 	// 				"height": "15px",
// 	// 				"maxWidth": "171px"
// 	// 			},
// 	// 			"medium": {
// 	// 				"size": "11px",
// 	// 				"height": "15px",
// 	// 				"maxWidth": "171px"
// 	// 			},
// 	// 			"large": {
// 	// 				"size": "11px",
// 	// 				"height": "15px",
// 	// 				"maxWidth": "171px"
// 	// 			},
// 	// 			"xlarge": {
// 	// 				"size": "11px",
// 	// 				"height": "15px",
// 	// 				"maxWidth": "171px"
// 	// 			}
// 	// 		},
// 	// 		"6": {
// 	// 			"small": {
// 	// 				"size": "9px",
// 	// 				"height": "13px",
// 	// 				"maxWidth": "149px"
// 	// 			},
// 	// 			"medium": {
// 	// 				"size": "9px",
// 	// 				"height": "13px",
// 	// 				"maxWidth": "149px"
// 	// 			},
// 	// 			"large": {
// 	// 				"size": "9px",
// 	// 				"height": "13px",
// 	// 				"maxWidth": "149px"
// 	// 			},
// 	// 			"xlarge": {
// 	// 				"size": "9px",
// 	// 				"height": "13px",
// 	// 				"maxWidth": "149px"
// 	// 			}
// 	// 		}
// 	// 	}
// 	// },
// 	"paragraph": {
// 		"small": {
// 			"size": "11px",
// 			"height": "15px",
// 			"maxWidth": "171px"
// 		},
// 		"medium": {
// 			"size": "14px",
// 			"height": "18px",
// 			"maxWidth": "192px"
// 		},
// 		"large": {
// 			"size": "15px",
// 			"height": "19px",
// 			"maxWidth": "235px"
// 		},
// 		"xlarge": {
// 			"size": "17px",
// 			"height": "21px",
// 			"maxWidth": "277px"
// 		},
// 		"xxlarge": {
// 			"size": "23px",
// 			"height": "27px",
// 			"maxWidth": "363px"
// 		}
// 	},
// 	"text": {
// 		"xsmall": {
// 			"size": "9px",
// 			"height": "13px",
// 			"maxWidth": "149px"
// 		},
// 		"small": {
// 			"size": "11px",
// 			"height": "15px",
// 			"maxWidth": "171px"
// 		},
// 		"medium": {
// 			"size": "12px",
// 			"height": "16px",
// 			"maxWidth": "192px"
// 		},
// 		"large": {
// 			"size": "15px",
// 			"height": "19px",
// 			"maxWidth": "235px"
// 		},
// 		"xlarge": {
// 			"size": "17px",
// 			"height": "21px",
// 			"maxWidth": "277px"
// 		},
// 		"xxlarge": {
// 			"size": "23px",
// 			"height": "27px",
// 			"maxWidth": "363px"
// 		}
// 	},
// };

